import { render, staticRenderFns } from "./advert-text-box.vue?vue&type=template&id=6470c06f"
import script from "./advert-text-box.vue?vue&type=script&lang=js"
export * from "./advert-text-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports